<div class="grid-item">
	<div class="image-container portrait">
		<a (click)="goToCreator(creator.slug)">
			<div class="image use-image-transition" [style.background-image]="'url(' + creator.cover + ')'"></div>

			<div class="gradient"></div>

			<div class="creator-meta">
				<span class="name" [innerHTML]="creator.name | safeHtml"></span>
				<span class="update-count">{{ creator.count }} updates</span>
			</div>
		</a>
	</div>
</div> 